import React from 'react';

import './SharedFolderList.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import BackButton from '../BackButton/BackButton.jsx';

const { Folder } = icons;

export default function SharedFolderList(props) {
  return (
    <section className="sharedFolderList">
      <BackButton />

      <ul>
        {props.list.map((item) => (
          <li key={item.id} style={{ backgroundImage: `url(${item.imageUrl}` }}>
            {link(
              <div className="sharedFolderList_item">
                <Folder />

                <p className="sharedFolderList_item_name">{item.displayName}</p>
              </div>,
              `/shared-folders/${item.name}`,
              props.nextLink
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
